import gerarXls from "../../../helpers/geraXls";

export default gerarXls;
